import React from 'react';
export class IconWithComments extends React.Component {
  render() {
    return (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-outside-1_12530_29856" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"
              fill="black">
          <rect fill="white" width="14" height="14" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.09848 10.4614C1.40657 9.48334 1 8.28915 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13C5.68895 13 4.47612 12.5795 3.489 11.866L1.7059 12.2939L2.09848 10.4614Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.09848 10.4614C1.40657 9.48334 1 8.28915 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13C5.68895 13 4.47612 12.5795 3.489 11.866L1.7059 12.2939L2.09848 10.4614Z"
          fill="#3455DD"
        />
        <path
          d="M2.09848 10.4614L2.91483 9.88381L3.16817 10.2419L3.07629 10.6708L2.09848 10.4614ZM3.489 11.866L3.25567 10.8936L3.70244 10.7864L4.0748 11.0556L3.489 11.866ZM1.7059 12.2939L1.93923 13.2663L0.395553 13.6367L0.728088 12.0844L1.7059 12.2939ZM2 7C2 8.07559 2.33849 9.06914 2.91483 9.88381L1.28212 11.0389C0.474649 9.89755 0 8.50271 0 7H2ZM7 2C4.23858 2 2 4.23858 2 7H0C0 3.13401 3.13401 0 7 0V2ZM12 7C12 4.23858 9.76142 2 7 2V0C10.866 0 14 3.13401 14 7H12ZM7 12C9.76142 12 12 9.76142 12 7H14C14 10.866 10.866 14 7 14V12ZM4.0748 11.0556C4.89714 11.6499 5.90622 12 7 12V14C5.47169 14 4.0551 13.5091 2.90321 12.6765L4.0748 11.0556ZM1.47257 11.3215L3.25567 10.8936L3.72233 12.8384L1.93923 13.2663L1.47257 11.3215ZM3.07629 10.6708L2.68372 12.5034L0.728088 12.0844L1.12066 10.2519L3.07629 10.6708Z"
          fill="#3455DD"
          mask="url(#path-1-outside-1_12530_29856)"
        />
        <path d="M10 6H5" stroke="white" stroke-linecap="round" />
        <path d="M8 8H5" stroke="white" stroke-linecap="round" />
      </svg>
    );
  }
}
